import React from 'react';

const ActivityDescription = ({ description }: { description: string }) => (
  <div className='text-large-body'>
    {description}
  </div>
);

export default ActivityDescription;
